module.exports = __webpack_public_path__ + "img/video-3.9bc1c003.jpg";